import * as React from "react"
import * as Model from "../../../../model"
import * as Debt from "../debt-form-part"
import * as Ppi from "../ppi-form-part"
import * as Generality from "../generalities-form-part"
import * as Budget from "../budget-form-part"
import * as Observation from "../observation-form-part"
import * as Dob from "../dob-from-part"

export default class StandardFormPart
extends React.Component<Props, State> {
  constructor(props: Readonly<Props>) {
		super(props)
		this.state = {
      reportType: ReportNames.Personalized
    }
	}

  handleChange = (e: any): any=> {
    const reportType = e.target.value
    this.setState({reportType},() => {
      const report = this.getSelectedStandard(reportType)
      this.props.handleChange(report)
      this.props.changeGabarit(reportType.toString());
		})
  }

  render() {
    const reportTypeOptions: ReportTypeConfiguration[] = this.getValue()
		return <section>
      <div className="field">
        <label className="label">Type de rapport de gestion</label>
        <div className="control">
          <div className="select">
            <select  onChange={this.handleChange} defaultValue={this.state.reportType} >
              {reportTypeOptions.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
		</section>
	}

  private getValue():ReportTypeConfiguration[] {
    let reportTypeOptions = []
    const keys = Object.keys(ReportNames)
    for(const key of keys){
      const value = {value: key, label: ReportNames[key]}
      reportTypeOptions.push(value)
    }
    return reportTypeOptions
  }

	private getSelectedStandard(reportType: string): any {
    const report = Reports[reportType]
    return report
	}
}

export const ReportNames = {
  Personalized: "Personnalisé",
  Standard1: "Prospective",
  Standard2: "Rétrospective",
  DOB:"Débat d'Orientation Budgétaire"
}

export const Reports = {
  Personalized : null,
  Standard1 : [
    Generality.Names.Summary,
    Generality.Names.Glossary,
    Generality.Names.TitleEnabled,
    Generality.Names.RoundnessEnabled,
    Observation.Names.Allocations.Charts.Allocations,
    Observation.Names.Allocations.Charts.Global,
    Observation.Names.Allocations.Charts.OnePerAllocation,
    Observation.Names.Allocations.Charts.OnePerAllocationPerInhabitant,
    Observation.Names.AutoFinancing.Tables,
    Observation.Names.AutoFinancing.Charts.Global,
    Observation.Names.Investment.Tables,
    Observation.Names.Investment.Charts.Chapters,
    Observation.Names.Investment.Charts.Global,
    Observation.Names.Investment.Charts.OnePerChapter,
    Observation.Names.Investment.Charts.OnePerChapterPerInhabitant,
    Observation.Names.OperationExpense.Tables,
    Observation.Names.OperationExpense.Charts.Chapters,
    Observation.Names.OperationExpense.Charts.Global,
    Observation.Names.OperationExpense.Charts.OnePerChapter,
    Observation.Names.OperationExpense.Charts.OnePerChapterPerInhabitant,
    Observation.Names.OperationReceipts.Tables,
    Observation.Names.OperationReceipts.Tables,
    Observation.Names.OperationReceipts.Charts.Chapters,
    Observation.Names.OperationReceipts.Charts.Global,
    Observation.Names.OperationReceipts.Charts.OnePerChapter,
    Observation.Names.OperationReceipts.Charts.OnePerChapterPerInhabitant,
    Observation.Names.Tax.Tables,
    Observation.Names.Tax.Charts.Global,
    Observation.Names.Tax.Charts.Taxes,
    Observation.Names.Tax.Charts.OnePerTax,
    Observation.Names.Tax.Charts.OnePerTaxPerInhabitant,
    Debt.Names.ProspectiveEnabled,
    Debt.Names.RetrospectiveEnabled,
    Debt.Names.SimulatedLoansEnabled,
    Debt.Names.Annuities.Charts.Global,
    Debt.Names.CapitalReimbursement.Charts.Global,
    Debt.Names.InterestsReimbursement.Charts.Global,
    Debt.Names.RemainingCapital.Charts.Global,
  ],
	Standard2 : [
    Generality.Names.Summary,
    Generality.Names.Glossary,
    Generality.Names.TitleEnabled,
    Generality.Names.RoundnessEnabled,
    Observation.Names.Allocations.Charts.Allocations,
    Observation.Names.Allocations.Charts.Global,
    Observation.Names.Allocations.Charts.OnePerAllocation,
    Observation.Names.Allocations.Charts.OnePerAllocationPerInhabitant,
    Observation.Names.AutoFinancing.Tables,
    Observation.Names.AutoFinancing.Charts.Global,
    Observation.Names.Investment.Tables,
    Observation.Names.Investment.Charts.Chapters,
    Observation.Names.Investment.Charts.Global,
    Observation.Names.Investment.Charts.OnePerChapter,
    Observation.Names.Investment.Charts.OnePerChapterPerInhabitant,
    Observation.Names.OperationExpense.Tables,
    Observation.Names.OperationExpense.Charts.Chapters,
    Observation.Names.OperationExpense.Charts.Global,
    Observation.Names.OperationExpense.Charts.OnePerChapter,
    Observation.Names.OperationExpense.Charts.OnePerChapterPerInhabitant,
    Observation.Names.OperationReceipts.Tables,
    Observation.Names.ProgressOperationExpense.Tables,
    Observation.Names.ProgressOperationReceipts.Tables,
    Observation.Names.OperationReceipts.Charts.Chapters,
    Observation.Names.OperationReceipts.Charts.Global,
    Observation.Names.OperationReceipts.Charts.OnePerChapter,
    Observation.Names.OperationReceipts.Charts.OnePerChapterPerInhabitant,
    Observation.Names.Tax.Tables,
    Observation.Names.Tax.Charts.Global,
    Observation.Names.Tax.Charts.Taxes,
    Observation.Names.Tax.Charts.OnePerTax,
    Observation.Names.Tax.Charts.OnePerTaxPerInhabitant,
    Debt.Names.ProspectiveEnabled,
    Debt.Names.RetrospectiveEnabled,
    Debt.Names.Annuities.Charts.Global,
    Debt.Names.CapitalReimbursement.Charts.Global,
    Debt.Names.InterestsReimbursement.Charts.Global,
    Debt.Names.RemainingCapital.Charts.Global
  ],
  DOB:[
    Generality.Names.Summary,
    Generality.Names.Glossary,
    Generality.Names.TitleEnabled,
    Generality.Names.RoundnessEnabled,
    Observation.Names.AutoFinancing.Tables,
    Observation.Names.AutoFinancing.Charts.Global,
    Observation.Names.Investment.Tables,
    Observation.Names.Investment.Charts.Global,
    Observation.Names.OperationCompare.Tables,
    Observation.Names.OperationCompare.BlankTable,
    Observation.Names.Synthesis.Synthesis,
    Observation.Names.OperationExpense.Tables,
    Observation.Names.OperationExpense.Charts.Chapters,
    Observation.Names.OperationExpense.Charts.Global,
    Observation.Names.OperationReceipts.Tables,
    Observation.Names.OperationReceipts.Charts.Chapters,
    Observation.Names.OperationReceipts.Charts.Global,
    Debt.Names.ProspectiveEnabled,
    Debt.Names.RetrospectiveEnabled,
    Debt.Names.Annuities.Charts.Global,
    Debt.Names.CapitalReimbursement.Charts.Global,
    Debt.Names.InterestsReimbursement.Charts.Global,
    Debt.Names.RemainingCapital.Charts.Global,
    Dob.Names.DOB.Tables
  ]
}

export interface Props {
	handleChange(report: any):void,
  changeGabarit(gab:string):void,
}

interface ReportTypeConfiguration {
  value: string,
  label: string
}

interface State {
  reportType: string
}



// WEBPACK FOOTER //
// ./src/component/management-report/form-parts/standard-type-form/index.tsx